import React from 'react';
import PropTypes from 'prop-types';
import TicketTypeEditForm from './TicketTypeEditForm';
import Drawer from 'components/form-components/Drawer';

const TicketTypeEditModal = ({ editMode, handleClose, refreshList, selectedRecordId }) => {
  return (
    <Drawer
      title={editMode ? 'text_edit_ticket_type' : 'text_add_new_ticket_type'}
      handleClose={handleClose}
      classes='theme-font-inter-light'
      style={{ width: '35rem' }}
      headerClasses='p-3'
      bodyClasses='p-3'
      bodyComponent={
        <TicketTypeEditForm
          isEditing={editMode}
          handleClose={handleClose}
          refreshList={refreshList}
          selectedRecordId={selectedRecordId}
        />
      }
    />
  );
};

TicketTypeEditModal.propTypes = {
  editMode: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  refreshList: PropTypes.func.isRequired,
  selectedRecordId: PropTypes.string,
};

export default TicketTypeEditModal;
